import { BR, ES, PT, US } from 'country-flag-icons/react/1x1'

const FLAGS = { BR, ES, PT, US }

/**
 * Bandeira em SVG (compatível com Windows; emojis regionais viram "BR", "US", etc.).
 * @param {{ flagCountry: string, className?: string }} props
 */
export default function LanguageFlagIcon({ flagCountry, className = '' }) {
  const Flag = FLAGS[flagCountry]
  if (!Flag) return null
  return <Flag className={className} aria-hidden />
}
